import axios from "axios";
import { Global } from '../utils/general';

const API_URL = Global.url;

class ReportService {
   
    generateSede(dateInit, dateEnd, id_sede, type) {
        const ruta = `${API_URL}/LP/report/sede?dateInit=${dateInit}&dateEnd=${dateEnd}&id_sede=${id_sede}&type=${type}`;
        return axios.post(ruta, null, {
            responseType: 'blob'
        }).catch((error) => {
            return error;
        });
    }

    exportReportMarksBySedeExcel(dateInit, dateEnd, id_sede, desSede) {
        const ruta = `${API_URL}/LP/report/marks/sede?dateInit=${dateInit}&dateEnd=${dateEnd}&id_sede=${id_sede}&desSede=${desSede}`;
        return axios.post(ruta, null, {
            responseType: 'blob'
        }).catch((error) => {
            return error;
        });
    }
}

export default new ReportService();
